import styled, { css } from "styled-components";

const containerStyles = css`
  ${(props) => props.containerStyles}
`;

const labelStyles = css`
  ${(props) => props.labelStyles}
`;

const inputStyles = css`
  ${(props) => props.inputStyles}
`;

const errorStyles = css`
  ${(props) => props.errorStyles}
`;

export const DropdownContainer = styled.div`
  position: relative;
  ${containerStyles}
`;

export const DropdownLabel = styled.label`
  font-size: 1rem;
  font-family: "Lato";
  line-height: 1;
  text-transform: initial;
  ${labelStyles}
  ${(props) =>
    props.required &&
    `&::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }`}
  ${(props) => props.disabled && "color: gray;"}
`;

export const DropdownOptionsList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-top: 0;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  width: 100%;
  max-height: 15.625rem;
  overflow-y: auto;
  z-index: 2;
  position: absolute;
  left: 0;
  right: 0;
`;

export const DropdownOptionsListItem = styled.li`
  border-bottom: 1px solid #ddd;
  padding: 0.5rem;
  font-size: 1rem;
  font-family: "Lato";
  line-height: 1;
  color: #474747;

  &:last-child {
    border-bottom: none;
  }
  &:hover,
  &:focus {
    cursor: pointer;
    color: white;
    background-color: #1bace4;
  }
`;

export const SelectedOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ccc;
  color: #474747;
  border-radius: 4px;
  padding: 0.375rem 0.625rem;
  > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 20rem;
  }

  ${inputStyles}
  ${(props) => props.disabled && "cursor: not-allowed;"}
  ${(props) => props.disabled && "border-color: gray;"}
  ${(props) =>
    props.disabled &&
    `> span {
    color: gray;
  }`}
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
  ${errorStyles}
`;

export const DisplayLabel = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #0a4986;
`;

export const DisplaySubLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #474747;
`;
